import { render, staticRenderFns } from "./CostBearerPaymentPreview.vue?vue&type=template&id=4e154c01&scoped=true"
import script from "./CostBearerPaymentPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerPaymentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e154c01",
  null
  
)

export default component.exports